export type PolicyProfileOsTab = "windows" | "linux" | "mac";

export const POLICY_PROFILES_PATH = "/policyProfiles";

export function normalizeProfileOs(os: string | undefined | null): PolicyProfileOsTab {
    const value = (os ?? "").toLowerCase();
    if (value.includes("linux")) return "linux";
    if (value.includes("mac")) return "mac";
    return "windows";
}

export const getProfileResourceNameField = (resourceType: string) => {
    const resourceNameField =
        resourceType === "app"
            ? "appPath"
            : resourceType === "folder"
                ? "path"
                : resourceType === "Group"
                    ? "cn"
                    : resourceType === "Publisher"
                        ? "friendlyName"
                        : "urlName";
    return resourceNameField;
};